import MyIconButton from '../Layout/MyIconButton';
import { faPen } from '@fortawesome/free-solid-svg-icons';

const ActionsBilledThirdPartiesRenderer = (props) => {
  return (
    <div style={{ width: '100%' }}>
      <MyIconButton className='classic-button' type='button' iconCenter={{ icon: faPen, type: 'fontAwesome' }}
                    styleCss={{ boxShadow: 'none', color: '#bb0060', height: '20px', margin: '5px' }}
                    href={`/panneau-administration/tiers-factures/edition?id=${props.data.id}`}
      />
    </div>
  );
}

export default ActionsBilledThirdPartiesRenderer;